"use strict";

var _ = require("underscore");
var usersAPI = require("app/util/api/users");
var UserSelector = require("app/shared/components/UserSelector/user-selector");
var UserSelectorLoading = require("app/shared/components/UserSelector/user-selector-loading");
var util = require("app/util/util");

var UserSelectorContainer = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    selectionType: React.PropTypes.oneOf(["checkbox", "radioButton"]),
    border: React.PropTypes.oneOf(["thin", "thick"]),
    color: React.PropTypes.oneOf(["green", "blue", "grey"]),
    className: React.PropTypes.string,
    forceState: React.PropTypes.bool,
    handleCustomSelection: React.PropTypes.func,
    users: React.PropTypes.arrayOf(React.PropTypes.shape({
      id: React.PropTypes.number.isRequired,
      name: React.PropTypes.string.isRequired,
      avatar: React.PropTypes.object,
      position: React.PropTypes.string
    })),
    selectedUsers: React.PropTypes.arrayOf(
      React.PropTypes.shape({ id: React.PropTypes.number }).isRequired
    )
  },
  getInitialState: function() {
    return { users: null };
  },
  componentDidMount: function() {
    var shouldGetUsersFromAPI = !Array.isArray(this.props.users) || !this.props.users.length;
    if (shouldGetUsersFromAPI) {
      usersAPI.getAll(this.handleGetUserSuccess);
    } else {
      var users = util.deepClone(this.props.users);
      this.setUsers(users);
    }
  },
  handleGetUserSuccess: function(body, response) {
    var users = _.chain(body).sortBy(function(user) { return user.name; })
      .sortBy(function(user) { return !user.active; }).value();

    this.setUsers(users);
  },
  setUsers: function(users) {
    var users_with_selection = this.applyPropSelectedUsers(users);
    let isAdmin = window && window.loggedUserIsAdmin == "1";

    this.setState({
      users: _.filter(users_with_selection, function(user) {
        return isAdmin || user.active || user.checked;
      })
    });
  },
  applyPropSelectedUsers: function(users) {
    var selectedUsersIds = _.pluck(this.props.selectedUsers, "id");
    return this.setCheckedProperty(users, selectedUsersIds);
  },
  setCheckedProperty: function(userList, selectedUsersIds) {
    return _.map(userList, function(user) {
      user.checked = _.contains(selectedUsersIds, user.id);
      return user;
    });
  },
  hasUsers: function(users) {
    return (this.state.users !== null);
  },
  handleOnSelect: function(users) {
    this.setState({ users: users });
    if(typeof this.props.handleCustomSelection === "function") {
      this.props.handleCustomSelection(users);
    }
  },
  render: function() {
    return (
      this.hasUsers()
      ? <UserSelector users={this.state.users}
          onSelectChange={this.handleOnSelect}
          selectionType={this.props.selectionType}
          color={this.props.color}
          border={this.props.border}
          className={this.props.className}
          forceState={this.props.forceState}/>
      : <UserSelectorLoading />
    );
  }

});

module.exports = UserSelectorContainer;



// WEBPACK FOOTER //
// ./app/shared/components/UserSelector/user-selector-container.jsx